import { Component, OnInit } from '@angular/core';
import { Methods } from '../../shared/methods';
import { HdLinkToMasterService } from "../../services/hdlinktomaster.service";
import swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: 'app-searchforhddlinktomaster',
  templateUrl: './searchforhddlinktomaster.component.html',
  styleUrls: ['./searchforhddlinktomaster.component.css'],
  providers: [HdLinkToMasterService]
})
export class SearchforhddlinktomasterComponent implements OnInit {

  public mtds: Methods = new Methods();

  public responseHdLinkToMaster: any[] = [];
  public contMasterItemHDD = 0;
  public contMasterItemNOTHDD = 0;
  public power = false;
  public typesearch;
  public busqueda = '';
  public token;

  constructor(private _service: HdLinkToMasterService) {
    this.token = JSON.parse(localStorage.getItem("token"));
  }

  ngOnInit() {
  }

  search() {
    $("#holis123456").show();
    $("#resultados").hide();
    this._service.searchElements(this.token, this.typesearch, this.busqueda).subscribe(
      r => {
        console.log(r);
        if (r.status == "success") {
          this.responseHdLinkToMaster = [];
          for (let item of r.data) {
            let element = JSON.parse(item.data);
            element.id = item.id;
            this.responseHdLinkToMaster.push(element);
          }

          this.contMasterItemHDD = this.responseHdLinkToMaster.length;

          this.contMasterItemNOTHDD =
            this.responseHdLinkToMaster.length - this.contMasterItemHDD;
            if (this.responseHdLinkToMaster.length) {
              $("#resultados").show();
            } else if (!this.removing) {
              this.mtds.notifyError('No items found matching your search');
            }
        } else {
          this.mtds.notifyError(r.msge);
        }
        $("#holis123456").hide();
        this.removing = null;
      }, error => {
        $("#holis123456").hide();
      }
    );
  }

  public removing = null;
  removeElementFromHDLinkTable(e) {
    console.log(e);
    this.removing = e.id;
    this._service.removeElementFromReport(this.token, e.id).subscribe(
      r => {
        console.log(r);
        this.search();
      }, error => { this.removing = null; }
    );
  }

}
